import React from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, Typography, IconButton, Box, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useTeamColors from '../hooks/useTeamColors';

const ScoreHistoryModal = ({ open, onClose, history, teamId }) => {
    const { teamColors } = useTeamColors();
    const teamColor = teamId === 1 ? teamColors.team1.main : teamColors.team2.main;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 16,
                    backgroundColor: 'rgba(30, 30, 30, 0.95)',
                    border: `2px solid ${teamColor}`
                }
            }}
        >
            <DialogTitle sx={{ color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" component="span" fontWeight="bold">
                    Historial de Puntos - Pareja {teamId}
                </Typography>
                <IconButton onClick={onClose} sx={{ color: 'white' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
            <DialogContent>
                {history && history.length > 0 ? (
                    <List sx={{ color: 'white' }}>
                        {[...history].reverse().map((entry, index) => (
                            <React.Fragment key={index}>
                                <ListItem alignItems="flex-start">
                                    <ListItemText
                                        primary={
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography variant="body1" fontWeight="bold" color="white">
                                                    {entry.type} {entry.actor ? `(${entry.actor})` : ''}
                                                </Typography>
                                                <Typography variant="body1" fontWeight="bold" sx={{ color: '#4CAF50' }}>
                                                    +{entry.points}
                                                </Typography>
                                            </Box>
                                        }
                                        secondary={
                                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                                                Mano: {entry.hand}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <Box py={4} textAlign="center">
                        <Typography variant="body1" color="gray">
                            No hay puntos registrados en esta partida.
                        </Typography>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ScoreHistoryModal;
